import cx from 'classnames';
import { noop } from 'lodash';
import PropTypes from 'prop-types';

import { DividerWithText } from 'src/components/DividerWithText';

import { getMenuCards } from '../../lib';
import { MenuCard } from '../MenuCard';
import { MenuSearchField } from '../MenuSearchField';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  onMenuCardClick: PropTypes.func.isRequired,
  onSearchFocus: PropTypes.func.isRequired,
  hideImages: PropTypes.bool,
  externalChannelMenuProps: PropTypes.shape({
    onConnectExternalChannel: PropTypes.func.isRequired,
    onCheckExternalChannelConnected: PropTypes.func.isRequired,
  }),
  shouldIncludeAudioVideoResources: PropTypes.bool,
};

const defaultProps = {
  className: '',
  hideImages: false,
  externalChannelMenuProps: null,
  shouldIncludeAudioVideoResources: false,
};

export const MenuContentDefault = ({
  className,
  onMenuCardClick,
  onSearchFocus,
  hideImages,
  externalChannelMenuProps,
  shouldIncludeAudioVideoResources,
}) => {
  const styles = useStyles();

  const menuCards = getMenuCards({
    hideImages,
    shouldIncludeExternalChannel: !!externalChannelMenuProps,
    checkExternalChannelConnected: externalChannelMenuProps?.onCheckExternalChannelConnected,
    shouldIncludeAudioVideoResources,
  });

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.menuCards}>
        {menuCards.map((menuCard) => (
          <MenuCard
            key={menuCard.type}
            menuCard={menuCard}
            onClick={onMenuCardClick}
          />
        ))}
      </div>

      <DividerWithText text="OR" />

      <MenuSearchField
        className={styles.searchField}
        value=""
        onChange={noop}
        onFocus={onSearchFocus}
      />
    </div>
  );
};

MenuContentDefault.displayName = 'MenuContentDefault';
MenuContentDefault.propTypes = propTypes;
MenuContentDefault.defaultProps = defaultProps;
